// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1JO66","icon":"SortAdornment_icon__FLwdW","up":"SortAdornment_up__2RXiC","down":"SortAdornment_down__28hiT","active":"SortAdornment_active__3QeBd"};